import styled from "styled-components";

export const SearchComponent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  /* background-image: linear-gradient(
    to bottom right,
    #265077,
    #022140,
    #494b68,
    #1e4258,
    #2d575d
  ); */
  background: linear-gradient(to bottom right, #0066eb 0%, #ff8ab3 100%);
`;
